import { t } from '@app/i18n';
import { Card, ErrorBanner, PageHeader } from '@zarya/ui';
import { useTenant } from './TenantSettings.api';
import { TenantCard } from './TenantCard';
import { DiscoveryCard } from './DiscoveryCard';
import { HumanSubjectChannelsCard } from './HumanSubjectChannelsCard';
import { IdentityRolesCard } from './IdentityRolesCard';
import s from './TenantSettings.module.css';

/**
 * T21 — Configurações do tenant. Ambientes e regras têm páginas dedicadas.
 *
 * - **Tenant** (T425): cliente, ambiente, trust domain (FR-114, FR-115).
 * - **Middleware** (T138): a ponte com a infraestrutura (FR-016, FR-017, FR-119).
 * - **Discovery** (T426): ativo/pausado, intervalo, última varredura (FR-117).
 * - **Canais do Human Subject** (T426): URA · cliente, SSO · funcionário (FR-116).
 * - **Papéis das identidades** (T427): quantidade, origem, editar, excluir (FR-118).
 *
 * Cada card salva o documento inteiro (`updateTenant`) por cima do que leu, com a
 * `version` — é o travamento otimista que impede um card de apagar o outro.
 */
export function TenantSettingsPage() {
  const tenant = useTenant();

  return (
    <>
      <PageHeader
        title={t('tenantSettings.page.title')}
        tip={t('tenantSettings.page.purpose')}
        icon="gear"
      />

      {tenant.isError ? (
        <ErrorBanner
          error={tenant.error}
          title={t('tenantSettings.page.error')}
          onRetry={() => void tenant.refetch()}
          hideLink
        />
      ) : null}

      {tenant.isLoading ? (
        <Card title={t('tenantSettings.tenant.title')}>
          <p className={s.carregando}>{t('tenantSettings.page.loading')}</p>
        </Card>
      ) : null}

      {tenant.data ? (
        <div className={s.cards}>
          <TenantCard tenant={tenant.data} />
          <DiscoveryCard />
          <HumanSubjectChannelsCard tenant={tenant.data} />
          <IdentityRolesCard />
        </div>
      ) : null}
    </>
  );
}
